import { render, staticRenderFns } from "./AnalysisElementVotes.vue?vue&type=template&id=361948ee&"
import script from "./AnalysisElementVotes.vue?vue&type=script&lang=js&"
export * from "./AnalysisElementVotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports